import { render, staticRenderFns } from "./ScoreDialog.vue?vue&type=template&id=3641ad6c&scoped=true"
import script from "./ScoreDialog.vue?vue&type=script&lang=js"
export * from "./ScoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641ad6c",
  null
  
)

export default component.exports